import React, { useState, useEffect } from "react";
import { Popup, Button, Label } from "semantic-ui-react";
import valores_curso from "../utils/home_functions/valores_curso";
import styled from "styled-components";
import limpar_titulo from "../utils/home_functions/limpar_titulo";
import { verify_mobile } from "../utils/Utils";
import {
  CardContainer,
  BottomInfo,
  MoreInfo,
  PriceInfo,
} from "./CardOfertaStyles";

const CardOferta = ({ curso }) => {
  const popUpContent = () => {
    const {
      numero_videos,
      carga_horaria,
      nivel,
      frase_vagas,
      url_amigavel,
    } = curso;
    const { slogan, topico1, topico2, topico3 } = curso.treinamento || {};
    const titulo = limpar_titulo(curso.titulo);

    return (
      <div className="tooltip_content ui container media">
        {
          <div>
            <section
              onclick={() => {
                window.open(`digital/${url_amigavel}`, "_blank");
              }}
            >
              <center>
                <p className="titulo-curso-tooltip">{titulo}</p>
              </center>{" "}
              <br />
              <div className="carga-horaria">
                <div className="item-carga-tooltip item-1">
                  <div>
                    <i className="ui play icon"></i>
                    {numero_videos} aulas
                  </div>
                </div>

                <div
                  className="item-carga-tooltip item-2"
                  style={{ marginLeft: "5%" }}
                >
                  <div>
                    <i className="ui time icon"></i>
                    {carga_horaria} horas
                  </div>
                </div>

                <div
                  className="item-carga-tooltip item-3"
                  style={{ marginLeft: "5%" }}
                >
                  {nivel === "" ? (
                    <div>
                      <i className="ui icon flag checkered"></i>Início Imediato
                    </div>
                  ) : (
                    <div>
                      <i className="ui icon flag checkered"></i>
                      {nivel}
                    </div>
                  )}
                </div>
              </div>
              <br />
              <p className="slogan-curso-tooltip">{slogan}</p>
              <div className="items_aprendera">
                <p className="item-curso-tooltip">• {topico1}</p>

                <p className="item-curso-tooltip">• {topico2}</p>

                <p className="item-curso-tooltip">• {topico3}</p>
              </div>
              <br />
            </section>

            <center>
              <p style={{ marginTop: -20, marginBottom: 10, color: "#F26201" }}>
                {frase_vagas}
              </p>
            </center>
          </div>
        }
      </div>
    );
  };

  const renderImage = () => {
    return (
      <div style={{ position: "relative", width: "100%" }}>
        {curso.faixa && curso.faixa.texto && (
          <Label
            as="a"
            style={{
              position: "absolute",
              zIndex: 2,
              marginLeft: "14px",
            }}
            content={curso.faixa.texto}
            color={curso.faixa.cor}
            ribbon
            onClick={() => window.open(`/digital/${curso.url_amigavel}`)}
          />
        )}

        <img
          style={{
            width: "100%",
          }}
          src={`https://files.voitto.com.br/cursos/small/${curso.url_amigavel}.jpg`}
          onClick={() => window.open(`/digital/${curso.url_amigavel}`)}
        />
      </div>
    );
  };

  return (
    <CardContainer>
      {!verify_mobile() ? (
        <Popup trigger={renderImage()} position="top center">
          {popUpContent()}
        </Popup>
      ) : (
        renderImage()
      )}

      <BottomInfo>
        <p style={{ textAlign: "center" }}>{curso.treinamento.slogan}</p>

        <MoreInfo>
          <PriceInfo>
            <p
              style={{
                textDecoration: "line-through",
              }}
            >
              {valores_curso(curso)["de_por"]}
            </p>

            {curso.valor != 0 ? (
              <>
                <p>
                  Por
                  {curso.id == "3840" ||
                  curso.id == "4064" ||
                  curso.id == "4134" ? (
                    <b> 12x </b>
                  ) : (
                    <b> 10x </b>
                  )}
                  de <b>{valores_curso(curso)["parcelado_html"]}</b>
                </p>

                <p>
                  ou <b>{valores_curso(curso)["avista"]}</b> à vista
                </p>
              </>
            ) : (
              <p>
                Por <b>GRATUITO</b>
              </p>
            )}
          </PriceInfo>

          <Button
            style={{
              height: "40px",
              fontSize: ".85714286rem",
            }}
            onClick={() => window.open(`/digital/${curso.url_amigavel}`)}
            color="orange"
          >
            Ver Mais
          </Button>
        </MoreInfo>
      </BottomInfo>
    </CardContainer>
  );
};

export default CardOferta;
